import { render, staticRenderFns } from "./DriverEntityDetails.vue?vue&type=template&id=2c36dc17&"
import script from "./DriverEntityDetails.vue?vue&type=script&lang=js&"
export * from "./DriverEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c36dc17')) {
      api.createRecord('2c36dc17', component.options)
    } else {
      api.reload('2c36dc17', component.options)
    }
    module.hot.accept("./DriverEntityDetails.vue?vue&type=template&id=2c36dc17&", function () {
      api.rerender('2c36dc17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DriverEntityDetails.vue"
export default component.exports